"use client"
import { ProductDetails } from "@/@types"
import Header from "@/components/ui/Header/Header"
import ProductsDetails from "@/components/products/ProductDetails"
import ProductTabs from "@/components/products/ProductTabs"
import ProductsAccordeon from "@/components/products/ProductsAccordeon"
import ProductsInfoGeneralLG from "@/components/products/ProductsInfoGeneralLG"
import { ProductCharacteristic } from "@/@types"
import useProductDetails from "@/hooks/useProductDetails"

type Props = {
  product: ProductDetails
  features: ProductCharacteristic[]
}

export default function ProductDetailsClient({ product, features }: Props) {
  const { breadcrumbMap, info, videos, documents, isIndustryView } = useProductDetails(product)

  return (
    <div className="bg-white">
      <Header
        variant="light"
        title={product.short_name}
        breadcrumbMap={breadcrumbMap}
        isIndustryView={isIndustryView}
      />
      <div className="bg-[linear-gradient(to_top,#30303012_20.73%,_#FAFAFA12_97.79%)]">
        <ProductsDetails product={product} />
      </div>

      <ProductsInfoGeneralLG product={product} />
      <ProductTabs features={features} info={info} videos={videos} documents={documents} />
      <ProductsAccordeon features={features} info={info} videos={videos} documents={documents} />
    </div>
  )
}
